<mat-drawer-container class="sidenav-container" autosize hasBackdrop="false">
  <mat-drawer #drawer class="sidenav" mode="side" position="end">
    <ul class="list-group">
      <li class="list-group-item list-group-item-action"><h3>Breakfast Menu</h3></li>
      <li class="list-group-item list-group-item-action clickable" >This Week's Breakfast</li>
      <li class="list-group-item list-group-item-action clickable" >Rotation List</li>
      <li class="list-group-item list-group-item-action clickable" >Lunch History</li>
      <li class="list-group-item list-group-item-action" >Restaurant Frequency</li>
    </ul>
  </mat-drawer>
  <span (click)="isOpen=!isOpen">
  <button class="sidenav-button" (click)="drawer.toggle(); changeIcon()">
    <fa-icon [icon]="icon" class="fa mr-1" style="font-size: 1.25em"></fa-icon>
  </button>
  </span>
</mat-drawer-container>
